import { useState } from "react";
import { can, useAuth } from "../../lib/auth";
import { CapChartsResumen } from "./CapCharts";
import { Comparativo } from "./Comparativo";

const OPC = [["credito", "Crédito"], ["captacion", "Captación"], ["comparativo", "Comparativo"]];

// Selector Crédito | Captación | Comparativo; las dos últimas vistas solo con captacion.ver (el servidor responde 403 a los demás).
export const VistaSelector = ({ children, testid = "vista" }) => {
  const { user } = useAuth();
  const [v, setV] = useState("credito");
  if (!can(user, "captacion.ver")) return children;
  return (
    <div className="space-y-3" data-testid={`${testid}-selector`}>
      <div className="trd inline-flex rounded-xl border border-[var(--trd-border)] p-0.5" role="tablist">{OPC.map(([k, l]) => (
        <button key={k} type="button" role="tab" aria-selected={v === k} onClick={() => setV(k)} data-testid={`${testid}-${k}`}
          className={`trd-mono rounded-lg px-3 py-1 text-xs ${v === k ? "bg-[var(--trd-surface-2)] text-white" : "text-[var(--trd-muted)] hover:text-white"}`}>{l}</button>))}</div>
      {v === "credito" ? children : v === "captacion" ? <CapChartsResumen /> : <Comparativo />}
    </div>
  );
};
